import OSM from 'ol/source/OSM';

import TileLayer from 'ol/layer/Tile';

import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';

import { get as getProjection } from 'ol/proj';

import { Layer } from './layer';

import { vector, VectorLayer } from './vector_layer';
import { wms, WMSLayer } from './wms_layer';
import { wmts, wmtsTileGrid, WMTSLayer } from './wmts_layer';

const brt = () => {
	const projection = getProjection('EPSG:28992');
    
	// taken from WMTS capabilities: https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0?request=getcapabilities&service=wmts
	// WMTS 1.0.0: standardized rendering pixel size
	const resolution = 12288000.0 * 0.00028 / projection.getMetersPerUnit();

	const resolutions = new Array(15);
    const matrixIds = new Array(resolutions.length);
    for (let z = 0; z < resolutions.length; ++z) {
        matrixIds[z] = z;
        resolutions[z] = resolution / Math.pow(2, z);
    }
    
	const origin = [-285401.92, 903401.92];    	
	const tileSpan = 256 * resolution;

	const extent = [
		origin[0],
		// add one to get proper bottom/right coordinate
		origin[1] - tileSpan,
		origin[0] + tileSpan,
		origin[1],    	
	];

    const rdGrid = new WMTSTileGrid({
        resolutions: resolutions,
        matrixIds: matrixIds,
        extent: extent
    });               

    const source = new WMTS({
        url: 'https://service.pdok.nl/brt/achtergrondkaart/wmts/v2_0',
        layer: 'standaard',
        matrixSet: 'EPSG:28992',
        format: 'image/png',
        projection: 'EPSG:28992',
        tileGrid: rdGrid,
        style: 'default'
    });
    
    const layer = new TileLayer({
    	extent: extent,
    	source: source
    });
    
    return new Layer(layer);
}

const osm = () => {
	const layer = new TileLayer({
		source: new OSM()
	});
	
	return new Layer(layer);
}

const layer_types = {
	brt,
	osm,
	vector, VectorLayer,
	wms, WMSLayer,
	wmts, wmtsTileGrid, WMTSLayer
}

export {
	layer_types
}